import {BaseCommandMessage, BaseResponseMessage} from "./base";

export namespace BuyPremiumCommandNamespace {
    export const COMMAND = 'buy_premium';

    export class Request extends BaseCommandMessage {
        constructor() {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly premiumUntil: number, readonly money: number) {
            super(COMMAND, id, true);
        }
    }
}
